"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRotate = exports.isSetViewerEqualStageViewer = exports.getViewerOptions = exports.getTextureMap = exports.getStateViewerOptions = exports.getSideView = exports.getRotateTo = exports.buildImageChain = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getSideView = function getSideView(side) {
  if (side === 'front') return ',view[front]';
  if (side === 'back') return ',view[back]';
  return '';
};
exports.getSideView = getSideView;
var buildImageChain = function buildImageChain(currentId, side, activeLogoGroup, activeColor) {
  var activeLogoSets = activeLogoGroup && Object.keys(activeLogoGroup).reduce(function (acc, groupLocation, key) {
    var _activeLogoGroup$grou, _activeLogoGroup$grou2, _activeLogoGroup$grou3, _activeLogoGroup$grou4, _activeLogoGroup$grou5, _activeLogoGroup$grou6, _Object$keys;
    if (!((_activeLogoGroup$grou = activeLogoGroup[groupLocation]) !== null && _activeLogoGroup$grou !== void 0 && _activeLogoGroup$grou.url)) return acc;
    if (side && side !== groupLocation) {
      return acc;
    }
    var timestamp = Date.now();
    var locationId = (_activeLogoGroup$grou2 = activeLogoGroup[groupLocation]) === null || _activeLogoGroup$grou2 === void 0 ? void 0 : _activeLogoGroup$grou2.locationId;
    var locationLogoUrl = "".concat((_activeLogoGroup$grou3 = activeLogoGroup[groupLocation]) === null || _activeLogoGroup$grou3 === void 0 ? void 0 : _activeLogoGroup$grou3.url, "?t=talph").concat(timestamp, "tome");
    var locationBgRemoval = ((_activeLogoGroup$grou4 = activeLogoGroup[groupLocation]) === null || _activeLogoGroup$grou4 === void 0 ? void 0 : _activeLogoGroup$grou4.bgRemoval) || 0;
    var locationPosition = ((_activeLogoGroup$grou5 = activeLogoGroup[groupLocation]) === null || _activeLogoGroup$grou5 === void 0 ? void 0 : _activeLogoGroup$grou5.position) || 'center';
    var locationLogsize = ((_activeLogoGroup$grou6 = activeLogoGroup[groupLocation]) === null || _activeLogoGroup$grou6 === void 0 ? void 0 : _activeLogoGroup$grou6.size) || 'large';
    var colorizeOption = side ? '1' : '0';

    // eslint-disable-next-line max-len
    var accSetup = "".concat(acc, "set=").concat(locationId, "[").concat(locationLogoUrl, "],").concat(locationId, "BGremove[").concat(locationBgRemoval, "],").concat(locationId, "Colorize[").concat(colorizeOption, "],").concat(locationId, "Pos[").concat(locationPosition, "],").concat(locationId, "Size[").concat(locationLogsize, "]");
    return key < ((_Object$keys = Object.keys(activeLogoGroup)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) - 1 ? "".concat(accSetup, "&") : accSetup;
  }, []);
  var sideView = getSideView(side);
  var chainProperties = ["set=color[#".concat(activeColor, "],prodID[").concat(currentId, "],type[web]").concat(sideView), activeLogoSets, 'call=url[file:global.type]', 'sink=format[webp]'];
  var finalChain = chainProperties.join('&');
  return finalChain;
};
exports.buildImageChain = buildImageChain;
var getTextureMap = function getTextureMap(activeTexture, activeLogoGroup, activeColor) {
  if ((activeTexture === null || activeTexture === void 0 ? void 0 : activeTexture.type) === 'vest') {
    return {
      Front: buildImageChain(activeTexture === null || activeTexture === void 0 ? void 0 : activeTexture.prodId, 'front', activeLogoGroup, activeColor),
      Back_01: buildImageChain(activeTexture === null || activeTexture === void 0 ? void 0 : activeTexture.prodId, 'back_01', null, activeColor),
      Back: buildImageChain(activeTexture === null || activeTexture === void 0 ? void 0 : activeTexture.prodId, 'back', activeLogoGroup, activeColor)
    };
  }
  return {
    Helmet: buildImageChain(activeTexture === null || activeTexture === void 0 ? void 0 : activeTexture.prodId, null, activeLogoGroup, activeColor)
  };
};
exports.getTextureMap = getTextureMap;
var getViewerOptions = function getViewerOptions(viewer) {
  var _viewer$options, _viewer$options2;
  return {
    model: viewer === null || viewer === void 0 ? void 0 : (_viewer$options = viewer.options) === null || _viewer$options === void 0 ? void 0 : _viewer$options.model,
    textureMap: _objectSpread({}, viewer === null || viewer === void 0 ? void 0 : (_viewer$options2 = viewer.options) === null || _viewer$options2 === void 0 ? void 0 : _viewer$options2.textureMap)
  };
};
exports.getViewerOptions = getViewerOptions;
var getStateViewerOptions = function getStateViewerOptions(visualizerChoices) {
  var _visualizerChoices$ac;
  return {
    model: visualizerChoices === null || visualizerChoices === void 0 ? void 0 : (_visualizerChoices$ac = visualizerChoices.activeTexture) === null || _visualizerChoices$ac === void 0 ? void 0 : _visualizerChoices$ac.model,
    textureMap: getTextureMap(visualizerChoices === null || visualizerChoices === void 0 ? void 0 : visualizerChoices.activeTexture, visualizerChoices === null || visualizerChoices === void 0 ? void 0 : visualizerChoices.activeLogoGroup, visualizerChoices === null || visualizerChoices === void 0 ? void 0 : visualizerChoices.activeColor)
  };
};
exports.getStateViewerOptions = getStateViewerOptions;
var isSetViewerEqualStageViewer = function isSetViewerEqualStageViewer(viewer, visualizerChoices) {
  var _JSON$stringify, _JSON$stringify2;
  var setViewerOptions = getViewerOptions(viewer);
  var stateViewerOptions = getStateViewerOptions(visualizerChoices);
  var formattedSetViewerOptions = JSON.parse((_JSON$stringify = JSON.stringify(setViewerOptions)) === null || _JSON$stringify === void 0 ? void 0 : _JSON$stringify.replace(/\?t=talph.*tome/, ''));
  var formattedStateViewerOptions = JSON.parse((_JSON$stringify2 = JSON.stringify(stateViewerOptions)) === null || _JSON$stringify2 === void 0 ? void 0 : _JSON$stringify2.replace(/\?t=talph.*tome/, ''));
  return {
    value: (0, _isEqual["default"])(formattedSetViewerOptions, formattedStateViewerOptions),
    stateViewerOptions: stateViewerOptions,
    data: {
      formattedSetViewerOptions: formattedSetViewerOptions,
      formattedStateViewerOptions: formattedStateViewerOptions
    }
  };
};
exports.isSetViewerEqualStageViewer = isSetViewerEqualStageViewer;
var getRotateTo = function getRotateTo(side) {
  var rotateData;
  var degreeOffset = 30;
  switch (side) {
    case 'Front':
      {
        rotateData = {
          initialAzimuthAngle: 0 - degreeOffset,
          polarAngle: 90,
          transition: true
        };
        break;
      }
    case 'Left':
      {
        rotateData = {
          initialAzimuthAngle: 90 - degreeOffset,
          polarAngle: 90,
          transition: true
        };
        break;
      }
    case 'Back':
      {
        rotateData = {
          initialAzimuthAngle: 180 - degreeOffset,
          polarAngle: 90,
          transition: true
        };
        break;
      }
    case 'Right':
      {
        rotateData = {
          initialAzimuthAngle: 270 - degreeOffset,
          polarAngle: 90,
          transition: true
        };
        break;
      }
    default: // no default
  }

  return rotateData;
};
exports.getRotateTo = getRotateTo;
var updateRotate = function updateRotate(viewer, rotateProperties) {
  viewer.rotateTo(rotateProperties === null || rotateProperties === void 0 ? void 0 : rotateProperties.initialAzimuthAngle, rotateProperties === null || rotateProperties === void 0 ? void 0 : rotateProperties.polarAngle, rotateProperties === null || rotateProperties === void 0 ? void 0 : rotateProperties.transition);
};
exports.updateRotate = updateRotate;
//# sourceMappingURL=helpers.js.map